import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Chart } from 'angular-highcharts';
import { ChartDefinition } from 'src/shared/models/chart-definintions.model';
import { ReportService } from 'src/shared/services/report.service';
import { ReportData } from 'src/shared/models/report-data.model';
import { Observable, Subscription, from } from 'rxjs';
import { ReportFilters } from 'src/shared/models/report-filters.model';
import { MiscUtil } from 'src/shared/utilities/misc.util';
import { ReportDataSet } from 'src/shared/models/report-dataset.model';
import { ShowReport } from 'src/shared/enum/show-report.enum';

@Component({
  selector: 'smt-measures-report',
  templateUrl: './measures-report.component.html',
  styleUrls: ['./measures-report.component.scss']
})

export class MeasuresReportComponent implements OnInit {
  private expandEventsSubscription: Subscription;
  private filterEventSubscription: Subscription; 

  measureAverageChart : Chart;
  measureTotalChart : Chart;
  measureBlankChart : Chart;
  staffingData: ReportData;
  chartDefinition: ChartDefinition = new ChartDefinition();
  loading: boolean;
  reportSubscription: Subscription;
  toggleReportSubscription: Subscription;
  showAverageBool:boolean;
  showTotalBool: boolean; 

  @Input() toggleReportClicked: Observable<void>;
  @Input() filtersUpdated: Observable<void>;
  @Input() reportFilters: ReportFilters;
  @Input() showReport: ShowReport;

  @Output() staffingDataUpdated = new EventEmitter();

  constructor(private _reportService:ReportService) { }

  ngOnInit() {
    this.drawEmpty();
    this.loading = true;
    if(!this.showReport)
      this.showReport = ShowReport.All;
    if (this.filtersUpdated)
      this.filterEventSubscription = this.filtersUpdated.subscribe(() => this.getData());
    if(this.toggleReportClicked){
      this.toggleReportSubscription = this.toggleReportClicked.subscribe(() => this.drawGrid());
    }
  }

  drawEmpty()
  {
    this.measureBlankChart = this.getReportSetup('Measures', []);   
  }

  drawGrid()
  {

    if (!this.staffingData)
      return;

    this.loading = true;

    this.drawMeasuresChart();
    this.drawAverageChart();
    this.loading = false;
  }

  drawMeasuresChart() {
    this.measureTotalChart = this.getReportSetup('Total Measures', this.staffingData.xAxis);
    this.drawChart(MiscUtil.getDataFilteredByDataSetName(this.staffingData, 'total'), this.measureTotalChart);
  }

  drawAverageChart() {
    this.measureAverageChart = this.getReportSetup('Average Measures', this.staffingData.xAxis);
    this.drawChart(MiscUtil.getDataFilteredByDataSetName(this.staffingData, 'average'), this.measureAverageChart);
  }

  getReportSetup(title: string, data: string[]): any
  {
    let chart = this.chartDefinition.getColumnTemplate
    (
      title,
      this.reportFilters.ReportView,
      'Measures',
      data,
      false,
      'Measures'
    );
    return chart;
  }

  drawChart(dataSet:ReportDataSet[],chart:Chart)
  {
    if (dataSet.length == 0)
      return;

    let chartSizeMinusOne = dataSet.length - 1;

    // Add all but the last entry with the re-draw flag set to false this speeds up chart drawing
    dataSet.slice(0,chartSizeMinusOne).forEach(dataSet =>
      {
        chart.addSeries({type: 'line', name: dataSet.name, 	data:  dataSet.data},false,true);
      });

    chart.addSeries({type: 'line', name: dataSet[chartSizeMinusOne].name, 	data:  dataSet[chartSizeMinusOne].data},true,true);
  }

  async getData()
  {
    this.loading = true;

    if(this.reportSubscription)
      this.reportSubscription.unsubscribe();

    this.reportSubscription = from(this._reportService.getMeasureReport(this.reportFilters))
                                                      .subscribe(x =>
                                                        {
                                                          this.staffingData = x;
                                                          this.staffingDataUpdated.emit(this.staffingData);
                                                          this.drawGrid();
                                                        });
  }

  ngOnDestroy() {
    if(this.filtersUpdated)
      this.filterEventSubscription.unsubscribe()
    if(this.reportSubscription)
      this.reportSubscription.unsubscribe();
    if(this.toggleReportSubscription)
      this.toggleReportSubscription.unsubscribe();
  }

}
